import { type IncomeSplitConfig } from '@fruitful/income-split';

import { requestBuilder } from '../../../http/RequestBuilder';

const useSaveIncomeSplit = requestBuilder.mutation<
    IncomeSplitConfig,
    Partial<IncomeSplitConfig>
>({
    endpoint: '/api/income-split/create',
    method: 'POST',
});

export default useSaveIncomeSplit;
